import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { CashflowAnalysisComponent} from './cashflow-analysis';
import { SharedModule } from './../../app/shared/shared.module';

@NgModule({
  declarations: [
    CashflowAnalysisComponent,
  ],
  imports: [
    IonicModule,
    SharedModule
  ],
  exports: [
    CashflowAnalysisComponent
  ]
})
export class CashflowAnalysisComponentModule {}



// WEBPACK FOOTER //
// ./src/components/cashflow-analysis/cashflow-analysis.module.ts